import React from "react";



const Language = ({ language, onRemovePressed}) =>{
    return(    
        <div className="card bg-light p-2 pr-1 mb-1">
            <div className="row">
                <div style={{color:"black"}} className="col"> {language.language} </div>
                {/* <div style={{color:"black"}} className="col"> {certification.file} </div> */}

                <div className="col text-right">
                    <button 
                        className="btn btn-danger btn-sm rounded-circle"
                        onClick={() => onRemovePressed(language)}
                    >
                        {/* <FontAwesomeIcon icon={faMinus} /> */}
                        Remove
                    </button>
                </div>
            </div>   
       </div>
    )
}

export default Language;
